import React, { ReactNode } from 'react';
import { WprBaseViewInfo } from '../../view/WprBaseViewInfo';
import { WprBaseComponent } from './WprBaseComponent';
import { WprValidErrorInfo } from '../../view/validation/WprValidErrorInfo';
import { WprRowInfo } from '../props/WprRowInfo';

/**
 * ビュー入力エラープロパティ情報
 */
interface IWprViewErrorProps {
	subView?: string;			// サブビュー名
	className?: string;			// クラス
	view: WprBaseViewInfo;		// ビュー情報
	tagName?: string;			// タグ名
	name?: string;				// コントロール名
	row?: WprRowInfo;			// 繰返し行データ
	dispMax?: number;			// 表示最大数
}

/**
 * ビュー入力エラーステータス情報
 */
interface IWprViewErrorState {
	errList?: WprValidErrorInfo[];		// エラーメッセージリスト
}

/**
 * ビュー入力エラーコントロール
 */
export class WprViewError extends WprBaseComponent<IWprViewErrorProps, IWprViewErrorState> {
	// コンストラクタ  -----------------------------------------------------------
	constructor(props: IWprViewErrorProps){
		super(props);
		this.props.view.addViewErrorControl(this, props.subView);
		this.state = {
			errList: null
		};
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * 描画
	 */
	public onRender(): ReactNode {
		if (this.state.errList == null)
			return null;
		let list = null;
		if (this.props.row)
			list = this.state.errList.filter(minfo => (this.props.name === undefined || this.checkControlName(minfo.controlName) === true) && minfo.rowIndex === this.props.row.index);
		else
			list = this.state.errList.filter(minfo => this.props.name === undefined || this.checkControlName(minfo.controlName) === true);
		if (this.props.dispMax && list.length > this.props.dispMax) 
			list = list.splice(0, this.props.dispMax);
		if (this.props.tagName && this.props.tagName === 'div') {
			const errors = list.map((minfo, index, array) => 
				<div className='wpr-view-error-msg' key={index}>{minfo.errorMessage}</div>
			);
			return (
				<>
					<div className={this.className('wpr-view-error')}>{errors}</div>
				</>
			);
		}
		else {
			const errors = list.map((minfo, index, array) =>
				<p className={this.className('wpr-view-error-msg')} key={index}>{minfo.errorMessage}</p>
			);
			return (
				<>
					{errors}
				</>
			);
		}
	}

	/**
	 * コントロール名称取得
	 * @returns コントロール名称
	 */
	public getName(): string {
		return 'WprViewError';
	}
	// --------------------------------------------------------------------------

	// public メソッド  ----------------------------------------------------------
	/**
	 * エラー情報リスト設定
	 * @param msgList エラー情報リスト
	 */
	public setErrorList(errList: WprValidErrorInfo[]): void {
		if (this.isMount == false)
			return;
		this.setState({
			errList: errList
		});
	}
	// --------------------------------------------------------------------------

	// private メソッド  ---------------------------------------------------------
	/**
	 * クラス取得
	 * @param cls 固定クラス 
	 * @returns クラス
	 */
	private className(cls: string): string {
		if (this.props.className)
			return this.props.className + ' ' + cls;
		return cls;
	}

	/**
	 * コントロール名チェック
	 * @param controlName コントロール名
	 * @returns trueの場合、対象コントロール
	 */
	private checkControlName(controlName: string): boolean {
		if (this.props.name.includes(',') === false)
			return controlName === this.props.name;
		let rtn = false;
		this.props.name.split(',').forEach(cname => {
			if (cname.trim() === controlName)
				rtn = true;
		});
		return rtn;
	}
	// --------------------------------------------------------------------------
}